namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmFunkcniMistoDenikSsl extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoDenikSslReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmFunkcniMistoDenikSslObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmFunkcniMistoDenikSslObj());
            this.detailObj.createBase({
                contentName: "detailAdmFunkcniMistoDenikSsl",
                contentCaption: "jres:33000615", //RC 33000615 : Navázaný spisový uzel na podací deník
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmFunkcniMistoDenikSsl", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmFunkcniMistoDenikSslObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmFunkcniMistoDenikSslReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0} - {1}".format(this.data["sslden"]?.toString(), this.data["ixs_fun"]?.toString()) 
        }

        setSxsDetail(): string {
            return "{0}#{1}#{2}#".format((this.data.ixs_fun) ? this.data.ixs_fun.toString() : "", (this.data.sslden) ? this.data.sslden.toString() : "", (this.data.subrada) ? this.data.subrada.toString() : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoDenikSslSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            data.subrada = 1;
            (this.cnt.isl.AdmFunkcniMistoDenikSsl.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmFunkcniMistoDenikSsl", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmFunkcniMistoDenikSsl.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, this.textPopis()?.toString());
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("sslden", Gordic.Prefabs.Select.sslsden(), {
                model: "model.sslden=value.sslden",
                itemTemplate: "{sslden}"
            })
            this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: false
            });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" })
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }
    }
}